const SERVICES = [
  {
    image:
      'https://storage.helloreaddy.io/project_files/72bb2555-7c62-4243-8368-e35694228ca3/80d99473-4ec8-4d83-9fb7-4c6f6fb23229_compressed_Package.webp',
    alt: 'National and international tour packages from Kochi - GlobeSync Travel',
    icon: 'ri-map-2-line',
    title: 'National & International Tour Packages',
    desc: 'From immersive domestic escapes to expansive international adventures departing from Kochi, we plan every detail of your dream vacation.',
  },
  {
    image:
      'https://storage.helloreaddy.io/project_files/72bb2555-7c62-4243-8368-e35694228ca3/621f9332-1712-4b28-9c0e-9ec4641df27c_compressed_Flight.webp',
    alt: 'Worldwide flight bookings from Ernakulam - GlobeSync Travel',
    icon: 'ri-flight-takeoff-line',
    title: 'Worldwide Flight Bookings',
    desc: 'Access competitive rates and optimal routing for domestic and international travel to any destination on the map.',
  },
  {
    image:
      'https://storage.helloreaddy.io/project_files/72bb2555-7c62-4243-8368-e35694228ca3/7974ee0d-35ac-48ff-b9b5-cc2f6abc0b9b_compressed_Hotel.webp',
    alt: 'Global hotel reservations - GlobeSync Travel',
    icon: 'ri-hotel-line',
    title: 'Global Hotel Reservations',
    desc: 'From convenient business transit hubs to luxury international resorts, we secure accommodations that match your exact itinerary.',
  },
  {
    image:
      'https://storage.helloreaddy.io/project_files/72bb2555-7c62-4243-8368-e35694228ca3/ff061b4d-2901-44fb-9377-f3d50a570fac_compressed_Passport.webp',
    alt: 'Comprehensive visa assistance services in Kochi - GlobeSync Travel',
    icon: 'ri-passport-line',
    title: 'Comprehensive Visa Services',
    desc: 'Navigate complex international travel requirements with ease. We provide expert guidance for global tourist and business visas, ensuring you are clear for takeoff.',
  },
];

export default function Services() {
  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28" id="services">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        {/* Section heading */}
        <div className="flex flex-col items-start gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] text-primary-600">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
              Our Services
            </span>
            <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-5xl">
              Premium Travel &amp; Tour Services in
              <span className="text-primary-600"> Ernakulam</span>
            </h2>
          </div>
          <p className="max-w-md text-base leading-relaxed text-foreground-600">
            One dedicated team for your tours, flights, hotels, and visas — so you
            travel light and land ready.
          </p>
        </div>

        {/* Cards */}
        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 md:mt-16 lg:grid-cols-4 md:gap-6">
          {SERVICES.map((s) => (
            <article
              key={s.title}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={s.image}
                  alt={s.alt}
                  title={`${s.title} — GlobeSync Travel`}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/30 to-transparent" />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                  <i className={`${s.icon} text-xl`} />
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold tracking-tight text-foreground-950">
                  {s.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                <a
                  href="#contact"
                  className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-primary-700 transition-colors group-hover:text-primary-600"
                >
                  Get a free quote
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}